import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

import { removeEmpty } from 'utils'

export const getNotificationSetupApi = (user_id) => {
  const config = {
    method: 'get',
    url: `/api/v1/notification/setup?user_id=${user_id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res?.data) {
        return responseSuccess({ data: res?.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const patchNotificationSetupApi = (
  user_id,
  {
    notification_setup_id,
    overdue_period,
    summary_type_id,
    schedule_type_id,
    eng_language,
    th_language,
    rop_value,
    ron_value,
    rop_risk_status_value,
    ron_risk_status_value,
  }
) => {
  const params = removeEmpty({
    notification_setup_id,
    overdue_period,
    summary_type_id,
    schedule_type_id,
    eng_language,
    th_language,
    rop_value,
    ron_value,
    rop_risk_status_value,
    ron_risk_status_value,
  })

  const config = {
    method: 'patch',
    url: `/api/v1/notification/setup?user_id=${user_id}`,
    data: params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
